import { ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    no: "01",
    title: "House Washing",
    desc: "Soft-wash treatment for stucco, stone, and modern siding. Restores warmth and original tone without surface damage.",
    img: "https://images.unsplash.com/photo-1570630856429-32cf3feef67c?crop=entropy&cs=srgb&fm=jpg&q=85",
    bullets: ["Stucco · Stone · Brick", "Soft-wash 500 PSI", "Mold + algae removal"],
  },
  {
    no: "02",
    title: "Driveway Cleaning",
    desc: "Hot-water surface cleaning that lifts oil, rust, and embedded grime from concrete and pavers.",
    img: "https://static.prod-images.emergentagent.com/jobs/1236a11f-ca38-4921-83f3-221e6d2210b6/images/eeca7660a0ba5df0d4c4fe7f702890060d484fb92e9a9724e8d46f4921587335.png",
    bullets: ["Concrete · Pavers · Asphalt", "Surface seal-ready finish", "Oil & tire stain removal"],
  },
  {
    no: "03",
    title: "Patio & Pavers",
    desc: "Edge-to-edge restoration of travertine, flagstone, and modern porcelain pavers. Optional re-sand & seal.",
    img: "https://images.unsplash.com/photo-1768215882809-99534393395d?crop=entropy&cs=srgb&fm=jpg&q=85",
    bullets: ["Travertine · Flagstone", "Re-sand polymeric joints", "Pool deck specialists"],
  },
  {
    no: "04",
    title: "Commercial Exterior",
    desc: "Storefronts, HOA portfolios, hospitality grounds. Scheduled programs that protect curb appeal year-round.",
    img: "https://images.unsplash.com/photo-1570630856413-a907aa093668?crop=entropy&cs=srgb&fm=jpg&q=85",
    bullets: ["Storefronts · HOAs", "Recurring contracts", "After-hours availability"],
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#09090B] py-24 sm:py-32 lg:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 sm:mb-24 items-end">
          <div className="lg:col-span-7">
            <p className="font-mono-small text-[#E5D0A1] mb-6">— What We Do</p>
            <h2 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl tracking-[-0.035em] leading-[1.02]">
              Four disciplines.
              <br />
              <span className="font-editorial italic text-white/60 font-normal">
                One obsessive standard.
              </span>
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9">
            <p className="font-body text-white/60 text-lg leading-relaxed">
              Every project gets a pre-wash inspection, a calibrated detergent
              mix, and a walk-through. No subcontractors. No upsells.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {SERVICES.map((s) => (
            <article
              key={s.no}
              data-testid={`service-card-${s.no}`}
              className="group relative bg-[#0d0d10] overflow-hidden h-[460px] sm:h-[520px] cursor-pointer"
            >
              <div
                className="absolute inset-0 bg-cover bg-center opacity-30 transition-all duration-[1.2s] ease-out group-hover:opacity-60 group-hover:scale-105"
                style={{ backgroundImage: `url(${s.img})` }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#09090B] via-[#09090B]/40 to-transparent" />

              <div className="relative h-full p-8 sm:p-10 flex flex-col justify-between">
                <div className="flex items-start justify-between">
                  <span className="font-mono-small text-[#E5D0A1]">{s.no}</span>
                  <ArrowUpRight
                    className="w-6 h-6 text-white/40 group-hover:text-[#E5D0A1] group-hover:rotate-45 transition-all duration-500"
                    strokeWidth={1.2}
                  />
                </div>

                <div>
                  <h3 className="font-display text-white text-3xl sm:text-4xl tracking-tight mb-4 transition-transform duration-500 group-hover:-translate-y-1">
                    {s.title}
                  </h3>
                  <p className="font-body text-white/60 text-base leading-relaxed max-w-md mb-6">
                    {s.desc}
                  </p>
                  <ul className="flex flex-wrap gap-2">
                    {s.bullets.map((b) => (
                      <li
                        key={b}
                        className="font-mono-small text-white/50 border border-white/15 px-3 py-1.5"
                      >
                        {b}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
